import { Component, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthPermissionsService } from '../../services/auth-permissions.service';
import { CommonDataSharingService } from '../../services/common-data-sharing.service';
@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class SidebarComponent {
  quotationCount: any = 0;
  public menuItems: any = [
    {
      path: 'dashboard',
      title: 'Dashboard',
      icon: 'ic_dashboard_active',
      type: 'link',
      Menusub: false,
      module: [],
    },
    {
      path: 'businesses',
      title: 'Businesses',
      icon: 'Ic_business_active',
      type: 'link',
      Menusub: false,
      module: ['View My businesses listing'],
    },
    {
      path: 'orders',
      title: 'Order',
      icon: 'ic_orders_active',
      type: 'link',
      Menusub: false,
      module: ['View order listing'],
    },
    {
      path: 'pickup-orders',
      title: 'Pickup orders',
      icon: 'ic_pickup_orders',
      type: 'link',
      Menusub: false,
      module: ['View pickup order listing'],
    },
    {
      path: 'category',
      title: 'Category management',
      icon: 'ic_category_management',
      type: 'link',
      Menusub: false,
      module: ['View Category Listing'],
    },
    {
      path: 'inventory',
      title: 'Inventory',
      icon: 'ic_inventory',
      type: 'link',
      Menusub: false,
      module: ['View & Update inventory'],
    },
    {
      path: 'delivery-agents',
      title: 'Delivery agents',
      icon: 'ic_delivery_agents',
      type: 'link',
      Menusub: false,
      module: ['View delivery agent listing'],
    },
    {
      path: 'quotation-requests',
      title: 'Quotation requests',
      icon: 'ic_quotation',
      type: 'link',
      badgeValue: this.quotationCount,
      badgeClass: 'quotation-count',
      Menusub: false,
      module: ['View quotation listing'],
    }, {
      path: 'invoices',
      title: 'Invoices',
      icon: 'ic_invoices',
      type: 'link',
      Menusub: false,
      module: ['View invoice listing'],
    },
    {
      path: 'notifications',
      title: 'Manage notifications',
      icon: 'ic_manage_notifications',
      type: 'link',
      Menusub: false,
      module: ['View notifications'],
    },
    {
      path: 'content-manage/business-admin',
      title: 'Content management',
      icon: 'ic_content_management',
      type: 'link',
      Menusub: false,
      module: ['View content management'],
    },
    {
      path: 'tickets/general-queries',
      title: 'Tickets',
      icon: 'ic_ticket',
      type: 'link',
      Menusub: false,
      active: false,
      module: ['View tickets for My Businesses'],
      // internalPath: ['tickets/general-queries']
    },
    {
      title: 'Settings',
      selected: false,
      icon: 'ic_settings',
      type: 'sub',
      Menusub: true,
      active: false,
      module: ['View cutoff time', 'View users', 'View delivery agent'],
      children: [
        {
          path: 'settings/user',
          icon: 'ic_user_roles',
          title: 'Users & roles',
          type: 'link',
          selected: false,
          page: 'View users',
          internalPath: ['settings/roles']
        },
        {
          path: 'settings/cutoff-time',
          title: 'Set cutoff time',
          type: 'link',
          icon: 'ic_setcutt_offtime',
          selected: false,
          page: 'View cutoff time'
        },
        {
          path: 'settings/delivery-charges',
          title: 'Set delivery charges',
          type: 'link',
          icon: 'ic_pickup_orders',
          selected: false,
          page: 'View delivery agent'
        },
      ],
    }


  ];
  
  constructor(private _commonDataService: CommonDataSharingService, private _authPermissions: AuthPermissionsService, private _activatedRoute: ActivatedRoute) {
    this.getQuotationCount();
  }

  private getQuotationCount(): void {
    this._commonDataService._getQuotationCount().subscribe({
      next: (res: any) => {
        this.quotationCount = res.data.pendingQuotationCount;
      }, error: (err: any) => {

      }
    })
  }

  getHeaderNotification(): void {
    const selectedTab: any = 0;
    this._commonDataService._getToggleNotification(selectedTab).subscribe({
      next: (res: any) => {
        this._commonDataService.notificationSidebarToHeader.next(res);
      }, error: (err: any) => {
        console.log(err);
      }
    })
  }

  // addActiveClass(): void {
  //   const path = this._activatedRoute.snapshot.url[0].path;
  //   console.log(path)
  // }

  toggleNavSubActive(item: any) {

    this.menuItems?.forEach((a: any) => {
      a.selected = false;
    })
    if (!item.active) {
      this.menuItems?.forEach((a: any) => {
        if (this.menuItems.includes(item)) {
          a.active = false;
        }
        if (!a.children) {
          return false;
        }
        a.children?.forEach((b: any) => {
          if (a.children.includes(item)) {
            b.active = false;
          }
          if (!b.children) {
            return false;
          }
          b.children?.forEach((c: any) => {
            if (b.children.includes(item)) {
              c.active = false;
            }
            if (!c.children) {
              return false;
            }
            return;
          });
          return;
        });
        return;
      });
    }
    item.active = !item.active;
    // console.log(this.menuItems);
  }

  toggleNavActive(item: any, i: any): void {
    // console.log(item);
    this.getQuotationCount();
    if (item.type != 'sub') {
      this.menuItems.forEach((a: any) => {
        a.selected = false;
      })
      this.menuItems[i].selected = true
    }
    if (!item.active) {
      this.menuItems.forEach((a: any) => {
        if (this.menuItems.includes(item)) {
          a.active = false;
        }
        if (!a.children) {
          return false;
        }
        a.children.forEach((b: any) => {
          if (a.children.includes(item)) {
            b.active = false;
          }
          if (!b.children) {
            return false;
          }
          b.children.forEach((c: any) => {
            if (b.children.includes(item)) {
              c.active = false;
            }
            if (!c.children) {
              return false;
            }
            return;
          });
          return;
        });
        return;
      });
    }
    item.active = !item.active;
    // console.log(this.menuItems);

  }

  toggleNavItem(childItem: any, pIndex: any, cIndex: any, pItem: any) {
    // console.log(childItem);
    // console.log(pItem);
    childItem.selected = true;
    pItem.active = true;

    // console.log(this.menuItems);

    // this.menuItems.forEach((item: any, ind: number) => {
    //   if (ind == pIndex) {
    //     item.children.forEach((b: any, index: any) => {
    //       if (index == cIndex) {
    //         pItem.active = true;
    //         pItem.selected = true;
    //       }
    //     })
    //   }
    // })
  }

  toggleNavActiveSubItem(i: any, int: any): void {
    this.menuItems.forEach((a: any, index: number) => {
      if (index == i) {
        a.children.forEach((b: any, index: any) => {
          if (index == int) {
            b.active = b.active ? false : true;
          }
        })
      }
    })
    // console.log(this.menuItems);

  }
  
  toggleSidebar() {
    document.querySelector('body')?.classList.toggle('sidenav-toggled');
  }

  checkModulePermission(moduleNames: any) {
    if (moduleNames.length > 0)
      return moduleNames.some((sub: any) => this._authPermissions.authPermissionsList.some((str: any) => str.toLowerCase().includes(sub.toLowerCase())));
    return true;
  }

  checkPagePermission(pageName: any) {
    // return true;
    if (pageName.length > 0)
      return this._authPermissions.authPermissionsList.some((str: any) => str.toLowerCase().includes(pageName.toLowerCase()));
    return true;
  }

}
